import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select, AutoComplete } from 'antd';

const { Option } = Select;

const formattedAndSortedDriverOptions = (drivers) =>
  drivers
    .map((driver) => ({ ...driver, fullName: `${driver.firstName} ${driver.lastName}` }))
    .sort((a, b) => a.fullName?.localeCompare(b.fullName))
    .map((driver) => (
      <Option key={driver.driverId} value={driver.driverId.toString()}>
        {driver.fullName}
      </Option>
    ));

export default function DriverFilter({ onSelect, drivers, value }) {
  const [currentInput, setCurrentInput] = useState(null);

  const clearValues = () => {
    setCurrentInput(null);
    onSelect(null);
  };

  const onChange = (input) => {
    if (!input) {
      clearValues();
    }
    return setCurrentInput(input);
  };

  const getValue = () => {
    if (value === '' && currentInput) {
      // Handle 'clear all' from parent which doesn't know about `currentInput`
      clearValues();
      return null;
    }
    return currentInput || value;
  };

  return (
    <div className={`filter-container ${value ? 'active' : ''}`}>
      <img src="/assets/icons/filters/car.svg" alt="Driver filter" />
      <AutoComplete
        allowClear
        style={{ width: '89%' }}
        dataSource={formattedAndSortedDriverOptions(drivers)}
        placeholder="Select a driver"
        filterOption={(inputValue, option) =>
          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={onSelect}
        onChange={onChange}
        value={getValue()}
      />
    </div>
  );
}

DriverFilter.propTypes = {
  onSelect: PropTypes.any.isRequired,
  drivers: PropTypes.array.isRequired,
  value: PropTypes.string,
};

DriverFilter.defaultProps = {
  value: null,
};
